export const APP_HEIGHT = 700;
